import './functions/bxslider';
import AOS from 'aos';
import colorbox from 'jquery-colorbox';
require('slick-carousel');
require('./polyfills/find-polyfill');

// Extend Jquery with simple toggleText function - used for More/Less buttons
$.fn.extend({
    toggleText: function(a, b){
        return this.text(this.text() == b ? a : b);
    }
});

// Extend jquery check if div is in viewport
$.fn.isOnScreen = function(){
    var win = $(window);

    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
};


$(window).on('load', function () {
    $('body').addClass('loaded');
});

let scrollRef = 0;
  $(window).on("resize scroll", function () {
    // increase value up to 10, then refresh AOS
    scrollRef <= 10 ? scrollRef++ : AOS.refresh();
  });


$(document).ready(function () {

     AOS.init({
        duration:1000,
        offset:5,
        delay:10,
      });

    //Mobile Menu
    $('.menu-toggle').click(function () {
        $(this).toggleClass('active');
        $('a.target-burger').toggleClass('toggled');
        $('.mobile-menu').slideToggle();
        $('body').addClass('menu-open');
    });


    // MOBILE BACK TO TOP 
    $('.footer-bar .back-to-top').on('click', function(){
        $('html,body').animate({
            scrollTop: 0
        }, 1000);
    });


    // IMAGE ROTATOR
     var hpSlider = $('.what-we-offer-rotator').bxSlider({
        speed: 500,
        pause: 8000,
        mode: 'fade',
        maxSlides: (window.innerWidth <= 767) ? 1 : 5,
        moveSlides: 1,
        shrinkItems: true,
        infiniteLoop: true,
        auto: true,
        pager: true,
        controls: false
    });


    // IMAGE ROTATOR - MOB ONLY
     var hpSlider = $('.mobile-image-rotator').bxSlider({
        speed: 500,
        pause: 8000,
        mode: 'fade',
        maxSlides: (window.innerWidth <= 767) ? 1 : 5,
        moveSlides: 1,
        shrinkItems: true,
        infiniteLoop: true,
        auto: true,
        pager: true,
        controls: false
    });


    // CONTACT FORM TEXTAREA AUTO GROW
    $("textarea").keyup(function(e) {
        while($(this).outerHeight() < this.scrollHeight + parseFloat($(this).css("borderTopWidth")) + parseFloat($(this).css("borderBottomWidth"))) {
            $(this).height($(this).height()+1);
        };
    });


    // GALLERY BLOCK
    if ($('.gallery-block').length) {

        //ALL
        // $('#all').on('click', function(){
        //     if(!$("#all").hasClass("active")) {
        //         $(this).addClass('active');
        //         $('#pumps, #pipework, #filtration, #ancillaries').removeClass('active');
        //         $('.gallery-item').hide();
        //         $('.gallery-item').show();
        //     }
        // });

        //PUMPS
        $('#pumps').on('click', function(){
            if(!$(".cat-pumps").is(":visible")) {
                $('#pumps, #pipework, #filtration, #ancillaries').removeClass('active');
                $(this).addClass('active');
                $('.gallery-item').hide();
                $('.gallery-item.cat-pumps').show();
                $('.gallery-open').show();

                $('html,body').animate({
                   scrollTop: $(".gallery-block").offset().top - 250
                });
            }
        });

        //PIPEWORK
        $('#pipework').on('click', function(){
            if(!$(".cat-pipework").is(":visible")) {
                $('#pumps, #pipework, #filtration, #ancillaries').removeClass('active');
                $(this).addClass('active');
                $('.gallery-item').hide();
                $('.gallery-item.cat-pipework').show();
                $('.gallery-open').show();

                $('html,body').animate({
                   scrollTop: $(".gallery-block").offset().top - 250
                });
            }
        });

        //FILTRATION
        $('#filtration').on('click', function(){
            if(!$(".cat-filtration").is(":visible") || $("#all").hasClass("active")) {
                $('#pumps, #pipework, #filtration, #ancillaries').removeClass('active');
                $(this).addClass('active');
                $('.gallery-item').hide();
                $('.gallery-item.cat-filtration').show();
                $('.gallery-open').show();

                $('html,body').animate({
                   scrollTop: $(".gallery-block").offset().top - 250
                });
            }
        });

        //ANCILLARIES
        $('#ancillaries').on('click', function(){
            if(!$(".cat-ancillaries").is(":visible") || $("#all").hasClass("active")) {
                $('#pumps, #pipework, #filtration, #ancillaries').removeClass('active');
                $(this).addClass('active');
                $('.gallery-item').hide();
                $('.gallery-item.cat-ancillaries').show();
                $('.gallery-open').show();

                $('html,body').animate({
                   scrollTop: $(".gallery-block").offset().top - 250
                });
            }
        });

        var colorBoxHeight;
        var colorBoxWidth;

        if ($(window).width() >= 1368) {
            colorBoxWidth= '1000px';
            colorBoxHeight = '900px';
        }
        if ($(window).width() < 1367) {
            colorBoxWidth= '800px';
            colorBoxHeight = '800px';
        }
        if ($(window).width() <= 1023) {
            colorBoxWidth= '700px';
            colorBoxHeight = '700px';
        }


        $(".target-pumps").colorbox({
            rel:'target-pumps', 
            opacity: 0.95, 
            transition:"none", 
            current: "{current} of {total}",
            width: '95%',
            height: '95%',
            maxWidth: colorBoxWidth,
            maxHeight: colorBoxHeight,
            onOpen: function(){
                $('body').css({ overflow: 'hidden' });
            },
              onClosed: function(){
                $('body').css({ overflow: '' });
            }
        });

        $(".target-pipework").colorbox({
            rel:'target-pipework', 
            opacity: 0.95, 
            transition:"none", 
            current: "{current} of {total}",
            width: '95%',
            height: '95%',
            maxWidth: colorBoxWidth,
            maxHeight: colorBoxHeight,
            onOpen: function(){
                $('body').css({ overflow: 'hidden' });
            },
              onClosed: function(){
                $('body').css({ overflow: '' });
            }
        });

        $(".target-filtration").colorbox({
            rel:'target-filtration', 
            opacity: 0.95, 
            transition:"none", 
            current: "{current} of {total}",
            width: '95%',
            height: '95%',
            maxWidth: colorBoxWidth,
            maxHeight: colorBoxHeight,
            onOpen: function(){
                $('body').css({ overflow: 'hidden' });
            },
              onClosed: function(){
                $('body').css({ overflow: '' });
            }
        });

        $(".target-ancillaries").colorbox({
            rel:'target-ancillaries', 
            opacity: 0.95, 
            transition:"none", 
            current: "{current} of {total}",
            width: '95%',
            height: '95%',
            maxWidth: colorBoxWidth,
            maxHeight: colorBoxHeight,
            onOpen: function(){
                $('body').css({ overflow: 'hidden' });
            },
              onClosed: function(){
                $('body').css({ overflow: '' });
            }
        });
    }



    // TEAM SLIDER
    if ($(window).width() > 1023) {
        $('.team-slider').slick({
            dots: false,
            arrows: false,
            infinite: false,
            speed: 300,
            variableWidth: true,
            swipeToSlide: true,
            adaptiveHeight: (window.innerWidth <= 1023) ? true : false
        });
    }



     // HIDE CF7 FORM ON SEND
    if ($('.wpcf7').length) {
        var wpcf7Elm = document.querySelector( '.wpcf7' );

        wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {
          $('.form-wrap').hide();
        }, false );
    }

});


// WEBPACK FOOTER //
// ./assets/js/main.js